// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"57":"3a17f596","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"57":"b0e52a74d727c7814494","293":"38189ee1a13bd5748dab","522":"08b26d60513241113764"}[chunkId] + ".js";
};